import { useState } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
// import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'
import { data } from './data/data_03_walk_ok.js'
import kuva from './images/peukku_350x430.png'
import Button from 'react-bootstrap/Button';



const WalkOk = ({ visibilityHandler, soundsOn }) => {


    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);


    function Jatka() {


        visibilityHandler("jatka portaisiin")

    }


    return (

        <div className='sceneContainer'>

            <div id='image' className='kuvaBox'>

                {/* <img className='sameSizeImg' src={kuva} alt="kuva" /> */}
                {/* <img src={kuva} alt="kuva" style={{ width: '280px' }} /> */}
                <img src={kuva} alt="kuva" />


            </div>

            <div id='question'>
                <h4>{(data.kysymysteksti != null && data.kysymysteksti != "") ? data.kysymysteksti : null}</h4>
            </div>

            <div id='actions'>
                <Button onClick={() => Jatka()}>Jatka</Button>


            </div>
        </div>
    )

}

export default WalkOk